<template>
  <div id="forgot-password">
    <div style="margin-top: 3%" class="row">
      <div class="col-md-3 custom-form">
        <div v-if="msg" class="alert alert-primary text-center alert-dismissable">
          {{$t('message.' + msg)}}
          <button style="cursor: pointer;" type="button" class="close" @click="dismissMessage">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="ibox text-center">
          <h4 class="custom-form-header">{{$t("message.resetPassword")}}</h4>
          <div class="ibox-body">
            <div class="form">
              <div class="row text-center">
                <div class="col-md-12 form-group">
                  <input v-model="email" type="text" class="form-control" :placeholder="$t('message.email')">
                </div>
                <div class="col-md-12">
                  <button class="btn btn-primary custom-form-button" @click.prevent="sendMail">{{$t('message.sendEmail')}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "ForgotPassword",
    data() {
      return {
        email: '',
        msg: null,
      }
    },
    methods: {
      sendMail() {
        let self = this;

        this.post(this.apiPrefix, this.authApiUrl + '/forgot-password/', '', {
          email: this.email,
        }).then(() => {
          self.msg = 'resetLink';
        }).catch(() => {
          self.msg = 'emailNotFound';
        });
      },
      dismissMessage(){
        this.msg = null;
      }
    }
  }
</script>

<style scoped>

</style>
